export default "__VITE_ASSET__f890095c__"